import { List } from "lodash";
import { CaseStudyWidget } from "../enums/case-study-widget.enum";
import { KeyValuePair } from "./key-value-pair.class";
import { CoInvestmentDetails } from "./co-investment-details.class";

export class CoInvestmentDashboard {
    summary!: CoInvestmentDetails;
    investmentHighlightsNarrative!: List<string>;
    performanceNarrative!: List<string>;
    risksNarrative!: string;
    widgets!: Record<CaseStudyWidget, KeyValuePair<string | number, number>[]>;
}
